import { defineStore } from "pinia";

export interface FilePreviewState {
	opened: boolean;
	fileId: string;
	fileName: string;
	documentLabel: string;
	subtitle: string;
}

export interface FilePreviewPayload {
	fileId: string;
	fileName: string;
	documentLabel?: string;
	subtitle?: string;
}

const getDefaultState = (): FilePreviewState => {
	return {
		opened: false,
		fileId: "",
		fileName: "",
		documentLabel: "",
		subtitle: ""
	};
};

export const useFilePreviewStore = defineStore({
	id: "filePreview",
	state: (): FilePreviewState => getDefaultState(),
	actions: {
		open({ fileId, fileName, documentLabel, subtitle }: FilePreviewPayload) {
			this.fileId = fileId;
			this.fileName = fileName;
			this.documentLabel = documentLabel || fileName;
			this.subtitle = subtitle || fileName;
			this.opened = true;
		},
		close() {
			Object.assign(this, getDefaultState());
		}
	}
});
